import List from "../../layout/List";
import Listitem from "../../layout/Listitem";

const BusinessHours = () => {
  return (
    <div className="mt-8">
      <h3 className="font-pop text-2xl font-bold text-darkGreen">
        Business Hours
      </h3>
      <div className=" mt-6 ml-8 flex w-[615px] gap-x-[296px]">
        <List className="flex flex-col gap-y-8 font-pop text-2xl font-medium text-primary">
          <Listitem dot="dot" title="Monday" />
          <Listitem dot="dot" title="Tuesday" />
          <Listitem dot="dot" title="Wednesday" />
          <Listitem dot="dot" title="Thursday" />
          <Listitem dot="dot" title="Friday" />
          <Listitem dot="dot" title="Saturday" />
          <Listitem dot="dot" title="Sunday" />
        </List>
        <List className=" flex flex-col gap-y-[36px] font-pop text-xl font-medium text-black text-opacity-70">
          <Listitem className="w-[182px] " time="8:00 AM - 5:00 PM" />
          <Listitem time="8:00 AM - 5:00 PM" />
          <Listitem time="8:00 AM - 5:00 PM" />
          <Listitem time="8:00 AM - 5:00 PM" />
          <Listitem time="8:00 AM - 5:00 PM" />
          <Listitem time="8:00 AM - 5:00 PM" />
          <Listitem time="8:00 AM - 5:00 PM" />
        </List>
      </div>
    </div>
  );
};

export default BusinessHours;
